<template>
  <div class="user-message">
    <div class="titles-right font-style">我的考试</div>
    <div class="">
      <div
        class="ma-t-20 flex ma-r-20"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <img :src="item.CourseImage" class="width30" />
        <div class="width60 flex flex-direction f-between ma-l-20">
          <div class="flex f-between">
            <div class="fon-16 bold">{{ item.CourseName }}</div>
          </div>
          <div class="c-8a ma-l-10 flex f-between">
            <div>考试时间：{{ item.Time }}</div>
            <div class="flex">
              <div
                class="ma-t-50 flex f-center f-jcenter btn-submit ma-r-20"
                @click="toDetail(item.CourseId)"
                v-if="item.StatusText != '合格'"
              >
                重新考试
              </div>
              <div
                class="bold b"
                :class="item.StatusText == '合格' ? 'c-green' : 'c-000'"
                v-text="item.StatusText == '合格' ? '及格' : '不及格'"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="dataList.length == 0" class="pa-t-100">
        <Empty></Empty>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyexam } from "../api";
export default {
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    this.loadDataList();
  },
  methods: {
    loadDataList() {
      getMyexam().then((res) => {
        this.dataList = res.data.Data;
      });
    },
    toDetail(id = 1) {
      this.$router.push({
        path: "/Learn-detail",
        query: { id: id },
      });
    },
  },
};
</script>

<style >
.btn-submit {
  width: 120px;
  height: 30px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #ffffff;
  background: #234775;
  cursor: pointer;
}
.c-green {
  color: green;
}
.c-red {
  color: red;
}
.titles-right:before {
  content: "|";
  display: inline-block;
  width: 4px;
  height: 19px;
  background: #234775;
  color: #234775;
  border-radius: 2px;
  margin-right: 8px;
}
.width920px {
  width: 920px;
}
.font-style {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
}
.tab-active {
  border-bottom: 2px solid #234775;
}

.img_certificate {
  width: 180px;
  height: 230px;
}
</style>